import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_document_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  running_no_1: fromDatatype.VarcharDatatypeInterface;
  running_no_2: fromDatatype.VarcharDatatypeInterface;
  running_no_3: fromDatatype.VarcharDatatypeInterface;
  running_no_4: fromDatatype.VarcharDatatypeInterface;
  running_no_5: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  claim_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_queue: fromDatatype.VarcharDatatypeInterface;
  posting_status_to_sales_order: fromDatatype.VarcharDatatypeInterface;
  fk_sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_sales_invoice: fromDatatype.VarcharDatatypeInterface;
  fk_sales_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_purchase_invoice: fromDatatype.VarcharDatatypeInterface;
  fk_purchase_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_purchase_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_payment_voucher: fromDatatype.VarcharDatatypeInterface;
  fk_payment_voucher_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_payment_voucher_line_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  duplicate_from_rejected: boolean;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_document_hdr_RowClass implements bl_aat_claim_document_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  running_no_1: fromDatatype.VarcharDatatypeInterface;
  running_no_2: fromDatatype.VarcharDatatypeInterface;
  running_no_3: fromDatatype.VarcharDatatypeInterface;
  running_no_4: fromDatatype.VarcharDatatypeInterface;
  running_no_5: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  claim_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_queue: fromDatatype.VarcharDatatypeInterface;
  posting_status_to_sales_order: fromDatatype.VarcharDatatypeInterface;
  fk_sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_sales_invoice: fromDatatype.VarcharDatatypeInterface;
  fk_sales_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_purchase_invoice: fromDatatype.VarcharDatatypeInterface;
  fk_purchase_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_purchase_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  posting_status_to_payment_voucher: fromDatatype.VarcharDatatypeInterface;
  fk_payment_voucher_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fk_payment_voucher_line_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  duplicate_from_rejected: boolean;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}
